export default class Globals {
    static getBaseUrl() {
        try {
            App;
        } catch (e) {
            return "/";
        }
        return App.Env.BaseUrl;
    }
}
//let isDev = true;
let isDev = false;
//CM imposto isDev=false; per il mio pc
Globals.API_KEY = "WEB.0.0";
Globals.URL_FETCH_BLOCK = "";
// Globals.URL_FETCH_BLOCK_DEV = '/Sounzone/wwwroot/pages/blocks/';
// Globals.URL_FETCH_BLOCK_DEMO = '/pages/blocks/';
if (isDev) {
    Globals.URL_FETCH_BLOCK = "/Sounzone/wwwroot/pages/blocks/";
} else {
    Globals.URL_FETCH_BLOCK = "/pages/blocks/";
}

// 230719 - PF
Globals.isRemoveTrackFromPlaylist = false;

// 230108 - PF 
Globals.WS_URL = "https://sounzone.com/szwsbeta/";
// Globals.WS_URL = "https://sz-backend02.azurewebsites.net/szwsbeta/"; // Dev Url

Globals.searchManager = null;

// 230807 - PF
Globals.userManager = null;

// 250506 - PF
Globals.dataManager = null;

// Mostra nella console i dati di tracking
Globals.SHOW_TRACKING_DATA = false;

// Nasconde i console.log di sviluppo
Globals.SHOW_ALL_CONSOLE_LOG = true;

// Mostra nella console le chiamate del service manager
//Globals.SERVICE_MANAGER_SHOW_CALLS = false;

// Esclude totalmente il processo fake
//Globals.SERVICE_MANAGER_USE_FAKE = true && (App.Env.globalKeySet == "dev");
